module.exports = __webpack_public_path__ + "img/Roadshow SMKN 1 Jakarta.8321e7eb.jpg";